var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	296510: {
		fallback: function() { return function() { return __webpack_require__(440961); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	620562: {
		fallback: function() { return function() { return __webpack_require__(296540); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	175410: {
		fallback: function() { return Promise.all([__webpack_require__.e(743), __webpack_require__.e(569)]).then(function() { return function() { return __webpack_require__(132196); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=11.7.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/css",

	},
	355797: {
		fallback: function() { return Promise.all([__webpack_require__.e(705), __webpack_require__.e(716)]).then(function() { return function() { return __webpack_require__(49716); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=2.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@contrast-security-inc/design-system-foundations",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [296510,620562];
__webpack_require__.federation.installInitialConsumes = function(options) { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"410": [
		175410
	],
	"507": [
		296510,
		620562
	],
	"797": [
		355797
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}